export default __webpack_public_path__ + "static/media/Photo 3 - BR - toit végétalisé.d50a16e4.jpg";